


export const isFunc = (prop) => typeof prop === 'function'